export default __webpack_public_path__ + "static/media/homepage.e83cb432.svg";